"use client";

import MoneyBackGuaranteeIcon from "public/next-public/common/icons/money-back-guarantee-light.svg";
import { FunctionComponent, useState } from "react";

import Modal from "@/components/design-system/modal";
import styles from "./returnGuarantee.module.scss";

interface ReturnGuaranteeProps {
  className?: string;
}
const ReturnGuarantee: FunctionComponent<ReturnGuaranteeProps> = ({ className }) => {
  const [thirtyDayGuaranteeDetailsVisible, setThirtyDayGuaranteeDetailsVisible] = useState(false);

  return (
    <>
      <section
        className={`${styles.ReturnGuarantee} ${className ?? ""}`}
        onClick={() => setThirtyDayGuaranteeDetailsVisible(true)}
      >
        <MoneyBackGuaranteeIcon width={64} height={64} aria-hidden className={styles["thirty-day-guarantee-image"]} />
        <div className={styles["thirty-day-guarantee-text-container"]}>
          <span className={styles["thirty-day-guarantee-title"]}>Net32 30 Day Money-Back Guarantee!</span>
          <span className={styles["thirty-day-guarantee-subtitle"]}>
            Purchase with peace of mind knowing your order is backed by our 30-day money-back guarantee.{" "}
            <button
              type="button"
              className={styles.learnMore}
              onClick={() => setThirtyDayGuaranteeDetailsVisible(true)}
            >
              Learn more
            </button>
            .
          </span>
        </div>
      </section>

      <Modal
        size="skinny"
        sizeDownMd="medium"
        show={thirtyDayGuaranteeDetailsVisible}
        onHide={() => setThirtyDayGuaranteeDetailsVisible(false)}
        title="Net32 30-Day Money-Back Guarantee"
      >
        <div className={styles.modalBody}>
          <p>
            Net32 works with trusted vendors, manufacturers, and distributors to help provide reliable products,
            responsive service, and a better purchasing experience.
          </p>
          <p>
            If a product does not meet expectations and is not covered by a manufacturer or vendor guarantee, Net32 will
            help make it right. We may provide a prepaid return label and arrange a replacement or reimbursement, based
            on the issue and eligibility.
          </p>
          <p>
            No additional return shipping charges apply when the return is approved under the Net32 30-Day Money-Back
            Guarantee.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default ReturnGuarantee;
